import TabLayout from './tabLayout.view';

export default TabLayout;
